module.exports = __webpack_public_path__ + "img/staline.5a38cb5a.png";